import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getTierDeviationsStreamId } from '../helpers';
import { getCurrentMediaSource, getCurrentTierId } from '../selectors';
export default function*() {
    const { mediaSource , tierId  } = yield select((state)=>({
            mediaSource: getCurrentMediaSource(state),
            tierId: getCurrentTierId(state)
        }));
    const streamId = getTierDeviationsStreamId(mediaSource, tierId);
    const isFetching = yield select(selectors.isFetching, streamId);
    if (isFetching) {
        return;
    }
    yield put(withOffset.actions.fetch(streamId));
}
